// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE cf-component-icon/src/svgtoreact.sh TO MODIFY

import React from 'react';
import PropTypes from 'prop-types';

var Spectrum = function Spectrum(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return React.createElement(
    'svg',
    {
      className: className,
      'aria-label': label,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16'
    },
    React.createElement('path', { d: 'M8.8 6.639H1.306a.262.262 0 0 0-.262.262V9.1a.262.262 0 0 0 .262.262H8.8a.262.262 0 0 0 .258-.262V6.9a.262.262 0 0 0-.258-.261zM2.531 8.282h-.685V7.6h.686zM8.8 9.9H1.306a.262.262 0 0 0-.262.262v2.2a.262.262 0 0 0 .262.262H8.8a.262.262 0 0 0 .262-.262v-2.2A.262.262 0 0 0 8.8 9.9zm-6.269 1.708h-.685v-.686h.686z' }),
    React.createElement('path', { d: 'M14.939 4.136a.3.3 0 0 0-.174-.238l-5.5-2.481h-.01a.306.306 0 0 0-.227 0h-.01L3.521 3.9a.3.3 0 0 0-.174.238A12.438 12.438 0 0 0 3.387 6h.842a10.533 10.533 0 0 1-.011-1.3.255.255 0 0 1 .148-.2l4.687-2.115a.258.258 0 0 1 .173 0L13.919 4.5a.255.255 0 0 1 .148.2c.006.069.525 6.921-4.865 8.924a.276.276 0 0 1-.124 0 6.961 6.961 0 0 1-.655-.3H6.856a7.747 7.747 0 0 0 1.428.922c-.012.008.768.346.771.346a.326.326 0 0 0 .17 0s.783-.339.771-.346c5.491-2.685 4.95-10.033 4.943-10.11z' })
  );
};

Spectrum.propTypes = {
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default Spectrum;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Spectrum.js
// module id = 1062
// module chunks = 1